var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-title-wrapper",attrs:{"data-aos":"fade-up"}},[_c('h2',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"section-subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }